// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__1IFkk","icon":"search_icon__14UL7","input":"search_input__oL3iF"};